import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { CiMenuFries } from 'react-icons/ci';
import { HiOutlineX } from 'react-icons/hi';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [offlineMessage, setOfflineMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setOfflineMessage('Vous êtes en ligne.');
      setTimeout(() => setOfflineMessage(''), 3000); // Masquer le message après 3 secondes
    };

    const handleOffline = () => {
      setIsOnline(false);
      setOfflineMessage('Vous êtes hors ligne. Les données peuvent ne pas être à jour.');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      window.location.reload();
    } else {
      navigate('/', { replace: true });
    }
  };

  const handleNavigation = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <header className="bg-white lg:mx-20 text-black p-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" onClick={handleLogoClick} className="text-2xl font-bold">EasySyntaxe</Link>
        <button onClick={toggleMenu} className="focus:outline-none">
          {isOpen ? <HiOutlineX className="text-2xl" /> : <CiMenuFries className="text-3xl" />}
        </button>
      </div>

      {/* Menu Latéral avec animation fluide */}
      <div className={`fixed inset-0 bg-black bg-opacity-75 transition-opacity duration-300 z-40 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={toggleMenu}>
        <div className={`fixed top-0 left-0 h-full w-64 bg-black text-white transform transition-transform duration-300 z-50 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
          <div className="flex justify-end p-4">
            <button onClick={toggleMenu} className="text-2xl">
              <HiOutlineX />
            </button>
          </div>
          <nav className="flex flex-col p-4 space-y-4">
            <button onClick={() => handleNavigation('/')} className="text-left hover:text-gray-300">Accueil</button>
            <button onClick={() => handleNavigation('/offers')} className="text-left hover:text-gray-300">
              Comparatif des offres <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full">Nouveau</span>
            </button>
            <button onClick={() => handleNavigation('/network/orange-côte-d\'ivoire')} className="text-left hover:text-gray-300">Syntaxes Orange</button>
            <button onClick={() => handleNavigation('/network/mtn-côte-d\'ivoire')} className="text-left hover:text-gray-300">Syntaxes MTN</button>
            <button onClick={() => handleNavigation('/network/moov-africa-côte-d\'ivoire')} className="text-left hover:text-gray-300">Syntaxes Moov</button>
            <button onClick={() => handleNavigation('/about')} className="text-left hover:text-gray-300">À propos</button>
          </nav>
        </div>
      </div>

      {/* Notification de mode hors ligne */}
      {offlineMessage && (
        <div className="fixed bottom-0 left-0 right-0 bg-red-500 text-white p-4 text-center">
          {offlineMessage}
        </div>
      )}
    </header>
  );
};

export default Header;